export default __webpack_public_path__ + "static/Subscribe-c670eb557db3f1133fefc034898fa8d9.svg";